module.exports = __webpack_public_path__ + "static/media/userProfileApproval.f0299485.svg";